import { AppExternalService } from '@commons/core/ui/app-external.service';

export const CHAT_FRAME_NAME = 'iadvize';

export interface IChatIadvizeFrame {
  show(container: HTMLElement): void;

  hide(): void;
}

export class ChatIadvizeFrame implements IChatIadvizeFrame {
  constructor(private readonly externalAppService: AppExternalService) {}

  show(container: HTMLElement): void {
    this.externalAppService.positionApplication(CHAT_FRAME_NAME, container);
    this.externalAppService.showApplication(CHAT_FRAME_NAME);
  }

  hide(): void {
    this.externalAppService.hideApplication(CHAT_FRAME_NAME);
  }
}
